module.exports = __webpack_public_path__ + "img/borderEdgeShapeWhite.9bb17437.svg";